import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListFilter from "components/list/ListFilter";
import ListPagination from "components/list/ListPagination";
import Preview from "./componnets/Preview";
import { handleSuccessMessages } from "store/auth";
import { toJalali } from "lib/helpers";

export default function Coupons() {
  const path = {
    baseRoute: "/panel/orders",
    aliasName: "خرید ها",
    type: "Order",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    createAndDownload,
    remove,
    listSearch,
    from,
    to,
    listFilter,
    total,
  } = useList();

  const [item, setItem] = useState(null);

  useEffect(() => {
    dispatch(getList(path));

    return () => {
      dispatch(clear());
    };
  }, []);

  const types = {
    CHARGE_WALLET: "شارژ کیف پول",
    BUY_MOVIE: "خرید فیلم",
    BUY_SCREENING: "خرید بلیت",
    BUY_LIVE_TICKET: "خرید بلیت لایو",
    BUY_SCREENING_CAFE: "خرید بلیت کافه",
    SUBSCRIPTION: "خرید اشتراک",
    MTN_SUBSCRIPTION: "بسته ایرانسل",
    BUY_PHYSICAL: "خرید از فروشگاه",
    BUY_FESTIVAL: "خرید پکیج جشنواره",
  };
  const status = {
    Success: (
      <span className="bg-theme-9 p-2 rounded text-gray-200 text-sm">موفق</span>
    ),
    Pending: (
      <span className="bg-theme-3 p-2 rounded text-gray-200 text-sm">
        در انتظار پرداخت
      </span>
    ),
    Created: (
      <span className="bg-theme-5 p-2 rounded text-gray-900 text-sm">
        ثبت شده
      </span>
    ),
    Failed: (
      <span className="bg-yellow-500 p-2 rounded text-gray-200 text-sm">
        نا موفق
      </span>
    ),
  };
  const gateways = {
    zarinpal: "زرین پال",
    mellat: "ملت",
    pasargad: "پاسارگاد",
    saman: "سامان",
    paypal: "پی پال",
    inappandroid: "پرداخت درون برنامه ای(adnroid)",
    inappcafebazar: "پرداخت درون برنامه ای(کافه بازار)",
    inappios: "پرداخت درون برنامه ای(ios)",
    reseller: "فروشنده",
    directdebit: "دایرکت دبیت",
  };
  const currency = {
    IRR: "تومان",
    USD: "دلار",
  };

  const filterItems = [
    {
      type: "SELECT",
      name: "reseller_id",
      label: "فروشنده",
      options: [
        { label: "vod", value: 1 },
        { label: "حرفه هنرمند", value: 66850 },
        { label: "تیوال", value: 30360 },
        { label: "تد ایکس", value: 86752 },
        { label: "فروشندگان دیگر", value: "others" },
      ],
    },
    {
      type: "SELECT",
      name: "type",
      label: "نوع",

      options: [
        { label: "شارژ کیف پول", value: "CHARGE_WALLET" },
        { label: "خرید فیلم", value: "BUY_MOVIE" },
        { label: "خرید بلیت", value: "BUY_SCREENING" },
        { label: "خرید بلیت کافه", value: "BUY_SCREENING_CAFE" },
        { label: "خرید اشتراک", value: "SUBSCRIPTION" },
        { label: "بسته ایرانسل", value: "MTN_SUBSCRIPTION" },
        { label: "خرید پکیج جشنواره", value: "BUY_FESTIVAL" },
        { label: "خرید از فروشگاه", value: "BUY_PHYSICAL" },
        { label: "خرید بلیت لایو", value: "BUY_LIVE_TICKET" },
      ],
    },
    {
      type: "DATE_FROM_TO",
    },
    {
      type: "TEXT",
      name: "product_name",
      label: "محصول",
    },
    {
      type: "SELECT",
      name: "gateway",
      label: "درگاه",
      options: [
        { label: "زرین پال", value: "zarinpal" },
        { label: "ملت", value: "mellat" },
        { label: "پاسارگاد", value: "pasargad" },
        { label: "سامان", value: "saman" },
        { label: "پی پال", value: "paypal" },
        { label: "گوگل پی", value: "gpay" },
        { label: "درون برنامه ای اندروید", value: "inappadnroid" },
        { label: "درون برنامه ای ios", value: "inappaios" },
        { label: "توسط فروشنده", value: "reseller" },
        { label: "دایرکت دبیت", value: "directdebit" },
      ],
    },
    {
      type: "SELECT",
      name: "currency",
      label: "ارز",
      options: [
        { label: "تومان", value: "IRR" },
        { label: "دلار", value: "USD" },
      ],
    },
    {
      type: "PRICE_FROM_TO",
    },
    {
      type: "TEXT",
      name: "_user",
      label: "کاربر",
    },
    {
      type: "TEXT",
      name: "coupon_code",
      label: "کد تخفیف",
    },
    {
      type: "SELECT",
      name: "status",
      label: "وضعیت",
      options: [
        { label: "موفق", value: "Success" },
        { label: "درانتظار پرداخت", value: "Pending" },
        { label: "ناموفق", value: "Failed" },
        { label: "ثبت شده", value: "Failed" },
      ],
    },
  ];

  return (
    <>
      <Preview
        item={item}
        close={() => {
          setItem(null);
        }}
      />
      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">خرید ها</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <ListFilter path={path} items={filterItems} hasExcelReport />
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600 text-white">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2 text-xs">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">فروشنده</th>
                  <th className="whitespace-nowrap text-center">تاریخ</th>
                  <th className="whitespace-nowrap text-center">
                    شماره فاکتور
                  </th>
                  <th className="whitespace-nowrap text-center">شرح خرید</th>
                  <th className="whitespace-nowrap text-center">محصول</th>
                  <th className="whitespace-nowrap text-center">تعداد</th>
                  <th className="text-center">کاربر</th>
                  <th className="whitespace-nowrap text-center">مبلغ</th>
                  <th className="whitespace-nowrap text-center">تسویه از</th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item) => (
                    <tr className="intro-x">
                      <td>
                        <p className="ltr font-medium whitespace-nowrap text-center">
                          {item.seller ? item.seller.full_name : "vod"}
                        </p>
                      </td>
                      <td>
                        <p className="ltr font-medium whitespace-nowrap text-center">
                          {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}
                        </p>
                      </td>

                      <td className="text-center">
                        {item.type == "BUY_PHYSICAL" ? (
                          <>
                            <button
                              className="btn"
                              onClick={() => {
                                setItem(item);
                              }}
                            >
                              <Icons.Printer />
                              {item.id}
                            </button>
                          </>
                        ) : (
                          item.id
                        )}
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {types[item.type]}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.orderable && item.orderable.detail?.title}
                          {item.orderable && item.orderable.name}
                          {item.orderable && item.orderable.title}
                        </p>
                      </td>
                      <td>{item.count}</td>

                      <td>
                        <p className="font-xs  text-center ">
                          {item.user && item.user.full_name}
                          <br />
                          {item.user && item.user.user_name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.amount} {currency[item.currency]}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.gateway == "reseller" ? (
                            <>فروشنده:{item.amount}</>
                          ) : (
                            <>
                              {item.pga_amount > 0 && (
                                <>
                                  {gateways[item.gateway]}:{item.pga_amount}{" "}
                                  <br />
                                </>
                              )}

                              {item.discount_amount > 0 && (
                                <>
                                  {"کد تخفیف"}:{item.discount_amount}
                                  <br />
                                </>
                              )}

                              {item.wallet_amount > 0 && (
                                <>
                                  {"کیف پول"}:{item.wallet_amount}
                                </>
                              )}
                            </>
                          )}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {status[item.status]}
                        </p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
